// builds a fully‐qualified URL from any href (relative or absolute)
export function getAbsoluteUrl(href: string) {
  return new URL(href, process.env.NEXT_PUBLIC_DEV_URL);
}
